// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, Fragment, useContext, useEffect, useMemo, useRef,
    useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {NAVBAR_SLOTS, use_navbar} from './use_navbar';
import Icon_chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import Icon_menu from '../../../../hola/pub/img/hola2023/icons/24/menu.svg';
import Icon_x_close from '../../../../hola/pub/img/hola2023/icons/16/x_close.svg';
import Icon_chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import Icon_arrow_left from '../../../../hola/pub/img/hola2023/icons/24/arrow_left.svg';
import Icon_logout from '../../img/icons/logout.svg';
import Icon_support from '../../img/icons/16/support.svg';
// @ts-ignore
import {App_context} from '../../../../hola/pub/context.js';
import storage from '/util/storage.js';
import {use_login} from './use_login';
import {Button} from '../../../../hola/pub/lib/button';
import {use_region_countries} from './use_region_countries';
import {img_url} from '../img_url';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_prices} from '../plans/use_prices';
import styles from './mobile_nav.module.less';
import {Lang_picker} from './lang_picker';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
import {get_new_link, use_pathname}
    from '../../../../hola/pub/lib/use_pathname';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';

interface i_links_group_props {
    title: string | JSX.Element;
    items?: {title: string | JSX.Element; to: string; new_tab?: boolean}[];
    on_click?: ()=>void;
    on_expand?: ()=>void;
    cls?: string;
    title_icon?: JSX.Element;
}
const Links_group = (props: i_links_group_props)=>{
    const {title, items, on_click, on_expand, cls, title_icon} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const [expanded, set_expanded] = useState(false);
    const [style, set_style] = useState<CSSProperties>({});
    const list_ref = useRef<HTMLUListElement>();
    useEffect(()=>{
        if (!list_ref.current)
            return;
        const calc_style = ()=>{
            const b = list_ref.current.getBoundingClientRect();
            set_style({'--expander_height': `${b.height}px`} as CSSProperties);
        };
        calc_style();
        window.addEventListener('resize', calc_style);
        return ()=>{
            window.removeEventListener('resize', calc_style);
        };
    }, [list_ref.current]);
    const group_cls = cn(styles.links_group, cls, expanded && styles.expanded);
    return <div className={group_cls} style={style}>
      <p className={cn(theme.p1, theme.bold, styles.title)}
        onClick={()=>{
          set_expanded(v=>!v);
          if (on_expand)
            on_expand();
        }}>
        {title}
        {title_icon || <Icon_chevron_down className={styles.title_icon}/>}
      </p>
      {items && <ul ref={list_ref}>
        {items.map((l, i)=>{
            return <li key={i}>
              <Link to={l.to} className={cn(theme.P, theme.p1)}
                onClick={on_click} data-clickid={l.to}
                target={l.new_tab ? '_blank' : undefined}
                rel={l.new_tab ? 'noopener noreferrer' : undefined}>
                {l.title}
              </Link>
            </li>;
        })}
      </ul>}
    </div>;
};

const logo_links = {
    '/affiliate_frm': {to: '/pricing/premium?ref=affiliate_frm',
        target: '_blank', rel: 'noopener noreferrer'},
    '/download_ie': {to: null},
};

interface i_location_links_props {
  region: string;
  on_click: ()=>void;
}
const Location_links = (props: i_location_links_props)=>{
    const {region, on_click} = props;
    const {count, data, name, to} = use_region_countries(region, 5);
    const items = useMemo(()=>{
        const res = data.map(c=>({
            title: <Fragment>
              <span className={styles.c_name}>{c.name}</span>
              <span className={styles.count}>
                {c.count.toLocaleString()} proxies</span>
            </Fragment>,
            to: c.to,
        }));
        res.push({
          title: <Fragment>
            <span className={styles.c_name}>See all</span>
            <Icon_chevron_right/>
          </Fragment>,
          to,
        });

        return res;
    }, [data]);
    return <Links_group cls={styles.location_links} title={<Fragment>
      <span className={styles.r_name}>{name}</span>
      <span className={styles.count}>{count.toLocaleString()} proxies</span>
    </Fragment>} items={items} on_click={on_click}/>;
};

const Toolip_mobile_nav = (props: ReturnType<typeof use_navbar>)=>{
    const {theme} = use_theme({def: 'hola2023'});
    const {set_qs} = use_qs_with_set();
    const lang_picker_debug = use_debug_ui('lp');
    const {has_user, toggle, nav_opt, cp_link, cp_after_login,
        headlogo, nomenu, nologin, no_getstarted} = props;
    const [show_locations, set_show_locations] = useState(false);
    const on_toggle = ()=>{ toggle(); };
    // @ts-ignore
    const {is_client, user} = useContext(App_context);
    const {prices} = use_prices();
    const {pathname} = use_pathname();
    const debug_support_req_form = use_debug_ui('support_req_form');
    const show_support_req = pathname.includes('dashboard') &&
        debug_support_req_form;
    const global_homepage = is_client ? storage.get('global_homepage') : '';
    const link_props = global_homepage ? {to: global_homepage} :
        logo_links[pathname] || {to: '/'};
    const logo = nav_opt?.logo || 'hola_logo_letters.svg';
    const login_pos = nav_opt?.login_pos || 'top';
    const {on_login, on_signup} = use_login(cp_after_login, cp_link);
    const show_nav_menu = is_client && !headlogo && !nomenu;
    const regions = ['most_popular', 'Europe', 'Northern America',
       'South America', 'Asia', 'Africa'];
    const login_menu = <Fragment>
      <a className={styles.login} onClick={on_login}>Log in</a>
      {no_getstarted ? null : <div className={styles.start}>
        <Button color="black" size="sm" caption="Sign Up"
          on_click={on_signup} clickid="nav_start" round={false}/>
      </div>}
    </Fragment>;
    const resources = [
        {title: 'Documentation', to: '//docs.toolip.io/' +
            'proxy-networks/toolip-proxy-network', new_tab: true},
        {title: 'Help center', to: '//support.toolip.io/',
            new_tab: true},
        {title: 'Blog', to: '/blog'},
        {title: 'Use cases', to: '/use-cases'},
    ];
    const item_title_cls = cn(theme.P, theme.mono16, theme.med);
    const item_btn_cls = cn(theme.P, theme.p3);
    return <Fragment>
      {show_locations && <div className={styles.locations_header}>
        <span>Locations</span>
        <button onClick={()=>{ set_show_locations(false); }}
          className={styles.back_btn} ><Icon_arrow_left/> Back</button>
      </div>}
      <div className={styles.logo_container}
        data-slot={NAVBAR_SLOTS.mobile_left}>
        <div className={styles.burger} onClick={on_toggle}>
          <Icon_menu className={styles.icon_menu}/>
          <Icon_x_close className={styles.icon_close}/>
        </div>
        <Link {...link_props} className={cn(styles.logo, 'logo_global_class')}
          data-clickid="nav_mobile_logo">
          <img src={img_url(logo)}/>
        </Link>
      </div>
      <div data-slot={NAVBAR_SLOTS.mobile_mid}/>
      <div className={styles.menu} data-slot={NAVBAR_SLOTS.mobile_right}>
        {show_nav_menu && <div className={styles.icons}>
          {has_user && !nologin ? <Button color="transparent_black" size="sm"
            caption={<span>Dashboard</span>} to={cp_link}
            clickid="mobile_nav_dashboard" round={false} cls={styles.dashboard}
            icon_right={<Icon_chevron_right/>}
          /> : login_pos=='top' ? login_menu : null}
        </div>}
        <div className={styles.links_wrapper}>
          <div className={cn(theme.container, styles.links,
            !show_locations && styles.hidden)}>
            {regions.map(r=>{
              return <Location_links key={r} region={r}
                on_click={()=>{
                  set_show_locations(false);
                  toggle();
                }}/>;
            })}
          </div>
          <div className={cn(theme.container, styles.links,
            show_locations && styles.hidden)}>
            <Links_group title="Products" items={[
              {title: <Fragment>
                <span className={item_title_cls}>
                  Dedicated Datacenter <br/>Proxies</span>
              </Fragment>, to: get_new_link('/products/dedicated-datacenter')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Shared Datacenter <br/>Proxies</span>
              </Fragment>, to: get_new_link('/products/shared-datacenter')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Global ISP <br/>Proxies</span>
              </Fragment>, to: get_new_link('/products/isp-proxy')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Search Engine ISP <br/>Proxies</span>
              </Fragment>, to: get_new_link('/products/isp-proxy')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Rotating <br/>Residential Proxies</span>
              </Fragment>, to: get_new_link('/products/residential-proxy')},
            ]} on_click={on_toggle}/>
            <Links_group title="Location" on_expand={()=>{
              set_show_locations(true);
            }} title_icon={<Icon_chevron_right/>}/>
            <Links_group title="Resources" on_click={on_toggle}
              items={resources}/>
            <Links_group title="Pricing" items={[
              {title: <Fragment>
                <span className={item_title_cls}>
                  Dedicated Datacenter Proxies</span>
                <Button
                  caption={<Fragment>
                    <span className={item_btn_cls}>
                      ${prices.dedicated_dc.min_price_per_ip}/IP
                    </span>
                    <Icon_chevron_right/>
                  </Fragment>}
                  size="sm" round no_jump
                  fit cls={cn(styles.price_btn, styles.ddp)}
                />
              </Fragment>, to:
                get_new_link('/pricing/dedicated-data-center-proxies')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Shared Datacenter Proxies</span>
                <Button
                  caption={<Fragment>
                    <span className={item_btn_cls}>
                      ${prices.shared_dc.min_price_per_ip}/IP
                    </span>
                    <Icon_chevron_right/>
                  </Fragment>}
                  size="sm" round no_jump
                  fit cls={cn(styles.price_btn, styles.sdp)}
                />
              </Fragment>, to:
                get_new_link('/pricing/shared-data-center-proxies')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Global ISP <br/>Proxies</span>
                <Button
                  caption={<Fragment>
                    <span className={item_btn_cls}>
                      ${prices.isp.min_price_per_ip}/IP
                    </span>
                    <Icon_chevron_right/>
                  </Fragment>}
                  size="sm" round no_jump
                  fit cls={cn(styles.price_btn, styles.isp)}
                />
              </Fragment>, to: get_new_link('/pricing/isp-proxies')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Search Engine ISP Proxies</span>
                <Button
                  caption={<Fragment>
                    <span className={item_btn_cls}>
                      ${prices.isp_plus.min_price_per_ip}/IP
                    </span>
                    <Icon_chevron_right/>
                  </Fragment>}
                  size="sm" round no_jump
                  fit cls={cn(styles.price_btn, styles.isp_plus)}
                />
              </Fragment>, to:
                get_new_link('/pricing/search-engine-isp-proxies')},
              {title: <Fragment>
                <span className={item_title_cls}>
                  Rotating <br/>Residential Proxies</span>
                <Button
                  caption={<Fragment>
                    <span className={item_btn_cls}>
                      ${prices.smart_resi.min_price_per_gb}/GB
                    </span>
                    <Icon_chevron_right/>
                  </Fragment>}
                  size="sm" round no_jump
                  fit cls={cn(styles.price_btn, styles.srp)}
                />
              </Fragment>, to: get_new_link('/pricing/residential-proxies')},
            ]} on_click={on_toggle}/>
          </div>
          {user ? <div className={styles.logout_container}>
            {show_support_req && <Button cls={styles.support_req} caption={
              <>
                <Icon_support/>
                <span className={cn(theme.P, theme.p16)}>Support request</span>
              </>}
              color={'transparent_grey'} size={'sm'}
              on_click={()=>set_qs({support_form: '1'})}
            />}
            <Button cls={styles.logout} caption={
              <Fragment>
                <Icon_logout/>
                <span className={cn(theme.P, theme.p16)}>Log out</span>
              </Fragment>}
              color={'transparent_grey'} size={'sm'} on_click={()=>{
              etask(function*(){
                yield fetch('/users/logout/inline', {method: 'POST',
                  xhrFields: {withCredentials: true}});
                storage.clr_all();
                location.href = '/';
              });
              }}/>
            {lang_picker_debug && <Lang_picker direction='up'/>}
          </div> : login_pos=='burger' ? <div
            className={styles.login_container}>{login_menu}</div> : null}
          <div className={styles.nouser_picker}>
            {lang_picker_debug && !user && <Lang_picker direction='up'/>}
          </div>
        </div>
      </div>
    </Fragment>;
};

export const Mobile_nav = (props: ReturnType<typeof use_navbar>)=>{
    const {is_scrolled, opened, nav_opt} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const variant = nav_opt?.transparent ? 'transparent' : 'default';
    const nav_cls = cn(styles.mobile_nav, theme.root,
        styles.toolip_mobile_nav, styles[variant], {
        [styles.scrolled]: is_scrolled,
        [styles.opened]: opened,
    });
    // XXX dmitriiz: use logo_global_class only for temporary reason,
    // such as experiments
    return <div className={nav_cls}>
      <div className={cn(styles.container)}>
        <Toolip_mobile_nav {...props}/>
      </div>
    </div>;
};
